module.exports = __webpack_public_path__ + "index/img/icon_jisu.4d350cb6.svg";